<template>
  <div style="width:100%" class="px-6">
    <v-data-table
      v-bind="mergedTableProps"
      :options.sync="paginationOptions"
      @current-items="reloadCurrentItems"
    >
      <template #header>
        <slot name="header"></slot>
      </template>
      <template #item="props">
        <tr
          :class="['pointer disable-select', isSelected(props.item) ? 'accent' : '']"
          oncontextmenu="return false;"
          @click.left.exact="clickItem(props.item, 'base', $event)"
          @click.ctrl.exact="clickItem(props.item, 'ctrl', $event)"
          @click.shift.exact="clickItem(props.item, 'shift', $event)"
          @click.right.exact="clickItem(props.item, 'right', $event)"
        >
          <td
            v-for="header in headers"
            :key="'table-item-' + header.value"
          >
            <slot :name="'item.' + header.value" v-bind:item="props.item">
              {{props.item[header.value]}}
            </slot>
          </td>
        </tr>
      </template>
      <template #footer>
        <slot name="footer">
          <v-layout py-4 row align-center justify-space-around>
            <span>
              {{footerSelectedText}}
            </span>
            <v-btn 
              color="primary"
              @click="selected = []; $emit('input', selected)"
              :disabled="selected.length === 0"
            > 
              <!-- {{$t('message.inputs.oSelectTable.unselectButton')}} -->
              Eliminar selección
            </v-btn>
          </v-layout>
        </slot>
      </template>
    </v-data-table>    
    <v-menu
      v-model="showMenuAcciones" 
      id="showMenuAcciones"
      transition="scale-transition" origin="top left"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <v-list dense class="py-0">
        <v-list-item
          v-for="(accion, index) in acciones"
          :key="index"
          @click="realizarAccion(accion.event)"
        >
          <v-list-item-icon>
            <v-icon v-text="accion.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ accion.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'o-select-table',
  props: {
    propsExtra: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Array
    },
    serverItemsLength: {
      type: Number,
      default: null
    },
    items: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    acciones: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: true
    },
    textoSeleccionadosSingular: {
      type: String,
      // default () {
      // return this.$t('message.inputs.oSelectTable.selected')
      // }
      default: 'Seleccionado'
    },
    textoSeleccionadosPlural: {
      type: String,
      // default () {
      // return this.$t('message.inputs.oSelectTable.selectedMulti')
      // }
      default: 'Seleccionados'
    },
    textoBotonDeseleccionar: {
      type: String,
      // default () {
      // return this.$t('message.inputs.oSelectTable.unselectButton')
      // }
      default: 'Eliminar selección'
    },
    clave: {
      type: String,
      default: 'id'
    },
    options: {
      type: Object,
      default: () => {}
    },
    search: {
      type: String,
      default: ''
    },
    searchFields: {
      type: Array,
      default: () => null
    },
    multiSelect: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selected: [],
      currentItems: [],
      lastIndexClicked: 0,
      showMenuAcciones: false,
      x: 0,
      y: 0
    }
  },
  created () {
    this.selected = this.value
  },
  computed: {
    footerSelectedText () {
      return this.selected.length + ' ' + (this.selected.length === 1 ? this.textoSeleccionadosSingular : this.textoSeleccionadosPlural)
    },
    paginationOptions: {
      get () {
        return this.options
      },
      set (val) {
        this.$emit('update:options', val)
      }
    },
    mergedTableProps () {
      let def = {
        'search': this.search,
        'headers': this.headers,
        'items': this.items,
        'loading': this.loading,
        'dense': this.dense,
        'item-key': this.clave
      }
      if (this.searchFields === null) {
        def['searchFields'] = this.searchFields
      }
      if (this.serverItemsLength !== null) {
        def['server-items-length'] = this.serverItemsLength
      }
      return _.merge(def, this.propsExtra)
    }
  },
  methods: {
    reloadCurrentItems (payload) {
      this.currentItems = payload
      this.lastIndexClicked = 0
    },
    indexItem (item) {
      return this.currentItems.findIndex(x => x[this.clave] === item[this.clave])
    },
    isSelected (item) {
      return (this.indexSelected(item[this.clave]) !== -1)
    },
    indexSelected (key) {
      return this.selected.findIndex(x => x === key)
    },
    clickItem (item, type, event) {
      if (type !== 'base' && !this.multiSelect) {
        return
      }
      const indexClicked = this.indexItem(item)
      switch (type) {
        case 'base':
          this.selectBase(item)
          break
        case 'shift':
          this.selectShift(item, indexClicked)
          break
        case 'ctrl':
          this.selectCtrl(item)
          break
        case 'right':
          if (!this.isSelected(item)) {
            this.selectBase(item)
          }
          this.showMenu(event)
          break
      }
      this.lastIndexClicked = indexClicked
    },
    selectBase (item) {
      this.selected = []
      this.selected.push(item[this.clave])
      this.$emit('input', this.selected)
    },
    selectCtrl (item) {
      const index = this.indexSelected(item[this.clave])
      if (index === -1) {
        this.selected.push(item[this.clave])
      } else {
        this.selected.splice(index, 1)
      }
      this.$emit('input', this.selected)
    },
    selectShift (item, index) {
      const start = this.clamp(index < this.lastIndexClicked ? index : this.lastIndexClicked, 0, this.currentItems.length - 1)
      const end = this.clamp(index > this.lastIndexClicked ? index : this.lastIndexClicked, 0, this.currentItems.length - 1)
      // console.log(start + ' ' + end)
      let indexSelectedItem = -1
      for (let i = start; i <= end; i++) {
        indexSelectedItem = this.indexSelected(this.currentItems[i][this.clave])
        if (indexSelectedItem === -1) {
          this.selected.push(this.currentItems[i][this.clave])
        }
      }
      this.$emit('input', this.selected)
    },
    showMenu (e) {
      e.preventDefault()
      this.showMenuAcciones = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenuAcciones = true
      })
    },
    realizarAccion (accion) {
      this.$emit(accion, this.selected)
    }
  }
}
</script>